import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';
import MetaManager from './components/MetaManager';

// Sider
import Home from './pages/Home';
import Udlejning from './pages/Udlejning';
import UdlejningSlushice from './pages/UdlejningSlushice';
import UdlejningPopcorn from './pages/UdlejningPopcorn';
import UdlejningSoundbox from './pages/UdlejningSoundbox';
import UdlejningHoppeborg from './pages/UdlejningHoppeborg';
import UdlejningPoelsevogn from './pages/UdlejningPoelsevogn';
import UdlejningGlas from './pages/UdlejningGlas';
import UdlejningSugeroer from './pages/UdlejningSugeroer';
import UdlejningKoeleskabGlas from './pages/UdlejningKoeleskabGlas';
import UdlejningKoeleskabAlm from './pages/UdlejningKoeleskabAlm';
import UdlejningLilleFryser from './pages/UdlejningLilleFryser';
import UdlejningVarmeovn from './pages/UdlejningVarmeovn';
import UdlejningVarmekanon from './pages/UdlejningVarmekanon';
import TeltUdlejning from './pages/TeltUdlejning';
import TeltFirkantetBord from './pages/TeltFirkantetBord';
import TeltRundeBord from './pages/TeltRundeBord';
import TeltStole from './pages/TeltStole';
import TeltGulv from './pages/TeltGulv';
import TeltLyskaeder from './pages/TeltLyskaeder';
import TeltCafebord from './pages/TeltCafebord';
import Maskiner from './pages/Maskiner';
import MaskinDetaljer from './pages/MaskinDetaljer';
import Priser from './pages/Priser';
import About from './pages/About';
import Contact from './pages/Contact';
import Lejebetingelser from './pages/Lejebetingelser';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900 antialiased">
      <ScrollToTop />
      <MetaManager />
      <Header />

      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/udlejning" element={<Udlejning />} />
          <Route path="/udlejning/slushice-maskine" element={<UdlejningSlushice />} />
          <Route path="/udlejning/popcorn-maskine" element={<UdlejningPopcorn />} />
          <Route path="/udlejning/soundbox-3" element={<UdlejningSoundbox />} />
          <Route path="/udlejning/hoppeborg" element={<UdlejningHoppeborg />} />
          <Route path="/udlejning/poelsevogn" element={<UdlejningPoelsevogn />} />
          <Route path="/udlejning/glas" element={<UdlejningGlas />} />
          <Route path="/udlejning/sugeroer-med-ske" element={<UdlejningSugeroer />} />
          <Route path="/udlejning/koeleskab-med-glaslaage" element={<UdlejningKoeleskabGlas />} />
          <Route path="/udlejning/almindeligt-koeleskab" element={<UdlejningKoeleskabAlm />} />
          <Route path="/udlejning/lille-fryser" element={<UdlejningLilleFryser />} />
          <Route path="/udlejning/varmeovn-gas" element={<UdlejningVarmeovn />} />
          <Route path="/udlejning/varmekanon-gas" element={<UdlejningVarmekanon />} />

          <Route path="/telt-udlejning" element={<TeltUdlejning />} />
          <Route path="/telt-udlejning/firkantet-bord" element={<TeltFirkantetBord />} />
          <Route path="/telt-udlejning/runde-bord" element={<TeltRundeBord />} />
          <Route path="/telt-udlejning/stole" element={<TeltStole />} />
          <Route path="/telt-udlejning/gulv" element={<TeltGulv />} />
          <Route path="/telt-udlejning/lysk-der" element={<TeltLyskaeder />} />
          <Route path="/telt-udlejning/cafebord" element={<TeltCafebord />} />

          <Route path="/maskiner" element={<Maskiner />} />
          <Route path="/maskiner/:id" element={<MaskinDetaljer />} />
          <Route path="/priser" element={<Priser />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/lejebetingelser" element={<Lejebetingelser />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
      <CookieBanner />
      <FloatingCTA />
    </div>
  );
}
